export default __webpack_public_path__ + "static/media/image_media.85522b04.jpg";